/**
 * Created by Mayank.Jain1 on 19-10-2016.
 */

 define(['underscore', 'edge/platform/base/BaseCtrl'], (_, BaseCtrl)=> {
    // added '$rootScope' *Princy
    const fn = ($scope, $filter, $timeout, $anchorScroll, LocaleService, InsuranceSuiteMetadata, StateUtils, submissionViewModel, VinLookupService, $q, ModalService, InMemorySession)=> {
    const ctrl = Object.create(BaseCtrl);
    const submissionVM = submissionViewModel();
    const chosenQuoteId = StateUtils.activeDataForState(true).model.value.quoteData.offeredQuotes[0].publicID;
    const flowModel = StateUtils.activeDataForState(true).flowModel;

ctrl.init = ()=> {
    $anchorScroll();
    ctrl._setBindDataDefaultValues();
    $scope.$filter = $filter;
    $scope.startDate = new Date();
    $scope.disabled = false;
    $scope.states = InsuranceSuiteMetadata.get('pc').types.getTypelist('State').codes;
    $scope.bindData = submissionVM.bindData;
    $scope.bindData.chosenQuote.value = chosenQuoteId;
    $scope.phoneMask = LocaleService.getRegionSamplePhoneNumber().replace(/[0-8]/g, '9');
    $scope.prefillResponseFromFactory = InMemorySession.getPrefillData();
    //devendra prefill code started
    $scope.prefillDriverCheck = function(driver,index){
        let isPrefilledDriverCheck = false;
        if($scope.prefillResponseFromFactory && $scope.prefillResponseFromFactory.drivers){
            InMemorySession.getPrefillData().drivers.forEach((obj) => {
                if(driver.person.firstName !== "undefined" && obj.dateOfBirth && ( driver.eNCDateOfBirth && (typeof driver.eNCDateOfBirth == 'string' || typeof driver.eNCDateOfBirth.value !== "undefined")) ){
                    let encDob = InMemorySession.decryptData(driver.eNCDateOfBirth).split(' ')[0].split("-")
                    let d1 = new Date(encDob[0], encDob[1]-1, encDob[2]);
                    // let d1 = new Date(driver.dateOfBirth.year, driver.dateOfBirth.month, driver.dateOfBirth.day);
                    let d2 = obj.dateOfBirth;
                    d2.setHours(0, 0, 0, 0);
                    if(driver.person.firstName.toLowerCase() == obj.firstName.toLowerCase() && driver.person.lastName.toLowerCase() == obj.lastName.toLowerCase() && d1.getTime() == d2.getTime()){
                        isPrefilledDriverCheck = true;  
                    }
                }                
            });
        }
        if(isPrefilledDriverCheck){
            submissionVM.draftData.value.lobs.personalAuto.drivers[index].isPrefilledDriver = true;
        }else{
            submissionVM.draftData.value.lobs.personalAuto.drivers[index].isPrefilledDriver = false;
            $scope.allPrefillDriversFlag = false;
        }
    };
    $scope.prefillVehicleCheck = function(vehicle,index){
        let isPrefilledVehicleCheck = false;
        if(InMemorySession.getPrefillData() && InMemorySession.getPrefillData().vehicles){
            InMemorySession.getPrefillData().vehicles.forEach((obj) => {
                if(vehicle.encryptedVIN && ((typeof vehicle.encryptedVIN =='string' && obj.vin == vehicle.encryptedVIN) || (vehicle.encryptedVIN.value && obj.vin == vehicle.encryptedVIN.value))){
                    isPrefilledVehicleCheck = true;
                }   
            });
        }
        if(isPrefilledVehicleCheck){
            submissionVM.draftData.value.lobs.personalAuto.vehicles[index].isPrefilledVehicle = true;
        }else{
            submissionVM.draftData.value.lobs.personalAuto.vehicles[index].isPrefilledVehicle = false;
            $scope.allPrefillVehicleFlag = false;
        }
    };
    $scope.allPrefillDriversFlag = true;
    if(submissionVM.draftData.value.lobs.personalAuto.drivers && submissionVM.draftData.value.lobs.personalAuto.drivers.length > 0){
        for(let idxDriver in submissionVM.draftData.value.lobs.personalAuto.drivers){
            if(typeof submissionVM.draftData.value.lobs.personalAuto.drivers[parseInt(idxDriver)] != "undefined" && typeof InMemorySession.getPrefillData().drivers !== "undefined" && InMemorySession.getPrefillData().drivers.length > 0){
                $scope.prefillDriverCheck(submissionVM.draftData.value.lobs.personalAuto.drivers[idxDriver],parseInt(idxDriver));
            }else{
                submissionVM.draftData.value.lobs.personalAuto.drivers[idxDriver].isPrefilledDriver = false;
                $scope.allPrefillDriversFlag = false;
            }
        }
    }
    $scope.allPrefillVehicleFlag = true;
    if(submissionVM.draftData.value.lobs.personalAuto.vehicles && submissionVM.draftData.value.lobs.personalAuto.vehicles.length > 0){
        for(let idxVehicle in  submissionVM.draftData.value.lobs.personalAuto.vehicles){
            if(typeof submissionVM.draftData.value.lobs.personalAuto.vehicles[parseInt(idxVehicle)] != "undefined" && typeof InMemorySession.getPrefillData().vehicles !== "undefined" && InMemorySession.getPrefillData().vehicles.length > 0){
                $scope.prefillVehicleCheck(submissionVM.draftData.value.lobs.personalAuto.vehicles[idxVehicle],parseInt(idxVehicle));
            }else{
                submissionVM.draftData.value.lobs.personalAuto.vehicles[idxVehicle].isPrefilledVehicle = false;
                $scope.allPrefillVehicleFlag = false;
            }
        }
    }
    //devendra prefill code end
    $scope.draftData = submissionVM.draftData.value;

    $scope.chosenQuoteData = _.findWhere(submissionVM.quoteData.offeredQuotes.value, {publicID: chosenQuoteId});

};

ctrl.cancel = function () {
    flowModel.cancel(submissionVM);
};

ctrl.next = function () {
    flowModel.next(submissionVM);
};

ctrl.isAccountHolder = (driver)=> {
    return submissionVM.value.getAccountHolderPerson() === driver.person;
};

ctrl.lookupState = (state)=> {
    let stateName = _.findWhere($scope.states, {code: state});
    if (!stateName) {
        //try the country
        stateName = _.findWhere(InsuranceSuiteMetadata.get('pc').types.getTypelist('Country').codes, {code: state});
    }
    return stateName;
};

ctrl.driverSort = (driver)=> {
    if (ctrl.isAccountHolder(driver)) {
        return -1;
    }
    return driver.getDisplayName(undefined, $filter);
};

ctrl._setBindDataDefaultValues = () => {
    submissionVM.bindData.value = submissionVM.bindData.value || {};
    if (!submissionVM.bindData.billingAddress.value) {
        submissionVM.bindData.billingAddress.value = {};
        angular.copy(
            submissionVM.draftData.policyAddress.value,
            submissionVM.bindData.billingAddress.value
        );
    }
    submissionVM.bindData.contactPhone.value = submissionVM.bindData.contactPhone.value || '';
    submissionVM.bindData.contactEmail.value = submissionVM.bindData.contactEmail.value ||
        submissionVM.draftData.accountHolder.emailAddress1.value;
};

return ctrl.create($scope);
};
fn.$inject = ['$scope', '$filter', '$timeout', '$anchorScroll', 'LocaleService', 'InsuranceSuiteMetadata', 'StateUtils', 'submissionViewModel', 'VinLookupService', '$q', 'ModalService', 'InMemorySession'];

return fn;
});




/** WEBPACK FOOTER **
 ** ./app/customer/js/src/edge/quoteandbind/pa/controllers/PAPolicySummaryCtrl.js
 **/